import {
  LOAD_PAYMENTCHANNEL,
  SHOW_PAYMENTCHANNEL,
  CREATE_PAYMENTCHANNEL,
  UPDATE_PAYMENTCHANNEL,
  DELETE_PAYMENTCHANNEL,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    name: "",
    code: "",
    fee_amount: "",
    fee_type: "P",
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // case LOAD_PAYMENTCHANNEL.REQUEST:
    case UPDATE_PAYMENTCHANNEL.REQUEST:
    case CREATE_PAYMENTCHANNEL.REQUEST:
    case DELETE_PAYMENTCHANNEL.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false
      };
    case LOAD_PAYMENTCHANNEL.REQUEST:
      return {
        ...state,
        data: initialState.data,
        ...msg,
        loading: true,
        shouldReload: false
      };
    case SHOW_PAYMENTCHANNEL.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false
      };


    case LOAD_PAYMENTCHANNEL.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_PAYMENTCHANNEL.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_PAYMENTCHANNEL.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_PAYMENTCHANNEL.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_PAYMENTCHANNEL.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true
      };

    case LOAD_PAYMENTCHANNEL.FAILURE:
    case SHOW_PAYMENTCHANNEL.FAILURE:
    case CREATE_PAYMENTCHANNEL.FAILURE:
    case UPDATE_PAYMENTCHANNEL.FAILURE:
    case DELETE_PAYMENTCHANNEL.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false
      };

    default:
      return state;
  }
};
